var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar mb-2"},[(!_vm.hideButton)?_c('button',{staticClass:"bg-transparent",on:{"click":_vm.goBack}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"fa-solid fa-arrow-left"}})],1):_vm._e(),_c('h4',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }